import React, { useState, useEffect } from "react";

export function generateComplexCaptcha() {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let captchaText = "";
  for (let i = 0; i < 6; i++) {
    captchaText += characters.charAt(Math.floor(Math.random() * characters.length));
  }

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = 150;
  canvas.height = 50;

  ctx.fillStyle = "#f9f9f9";
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.strokeStyle = "#ccc";
  for (let i = 0; i < 7; i++) {
    ctx.beginPath();
    ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
    ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
    ctx.stroke();
  }

  ctx.font = "24px Arial";
  for (let i = 0; i < captchaText.length; i++) {
    ctx.fillStyle = `hsl(${Math.random() * 360}, 100%, 30%)`;
    ctx.fillText(captchaText[i], 15 + i * 20, 30 + (i % 2 === 0 ? -5 : 5));
  }

  return {
    imageUrl: canvas.toDataURL(),
    text: captchaText,
  };
}

function Captcha({ captcha, refreshCaptcha, userCaptcha, setUserCaptcha }) {
  const styles = {
    container: { display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" },
    captchaImage: { width: "120px", height: "45px", border: "1px solid #ccc" },
    input: { padding: "5px", width: "90px", height: "25px", borderRadius: "4px", textAlign: "center", border: "1px solid #ccc" },
    refreshButton: { padding: "8px", backgroundColor: "#1dd1a1", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer" },
  };

  return (
    <div>
      <div style={styles.container}>
        <img src={captcha.imageUrl} alt="Captcha" style={styles.captchaImage} />
        <input type="text" value={userCaptcha} onChange={(e) => setUserCaptcha(e.target.value)} placeholder="Enter captcha" style={styles.input} />
        <button style={styles.refreshButton} onClick={refreshCaptcha}>Refresh</button>
      </div>
    </div>
  );
}

export default Captcha;
